// extracted by mini-css-extract-plugin
module.exports = {"container":"container___2XU-J","lang":"lang___3UZBu","content":"content___232he","icon":"icon___1dSHb"};